import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
const ScheduleInterviewDialog = ({
  open,
  onOpenChange,
  assessment,
  defaultInterviewee,
}) => {
  const [selectedInterviewee, setSelectedInterviewee] = useState(
    defaultInterviewee || "",
  );
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [notes, setNotes] = useState("");

  const schedulableInterviewees = assessment.interviewees.filter((i) =>
    i.actions.includes("schedule"),
  );

  const handleSubmit = () => {
    // For now just close the dialog
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-lg font-display">
            Schedule Interview
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 pt-2">
          <div className="space-y-2">
            <Label>Assessment</Label>
            <Select value={assessment.id} disabled>
              <SelectTrigger>
                <SelectValue>{assessment.company}</SelectValue>
              </SelectTrigger>
              <SelectContent>
                <SelectItem value={assessment.id}>
                  {assessment.company}
                </SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label>Interviewee</Label>
            <Select
              value={selectedInterviewee}
              onValueChange={setSelectedInterviewee}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select interviewee" />
              </SelectTrigger>
              <SelectContent>
                {schedulableInterviewees.map((person) => (
                  <SelectItem key={person.name} value={person.name}>
                    {person.name} ({person.role})
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Date</Label>
              <Input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>
            <div className="space-y-2">
              <Label>Time</Label>
              <Input
                type="time"
                value={time}
                onChange={(e) => setTime(e.target.value)}
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label>Notes</Label>
            <Textarea
              placeholder="Discussion topics, preparation notes..."
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              rows={3}
            />
          </div>

          <Button className="w-full" onClick={handleSubmit}>
            Schedule Interview
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ScheduleInterviewDialog;
